import React from "react";
import { Trash2 } from "lucide-react";
import { QUOTE_STATUSES } from "@/data/services";
import { EmptyState } from "@/components/admin/AdminBits";

export function QuotesPanel({ quotes, onStatusChange, onDelete }) {
  if (quotes.length === 0) {
    return (
      <div data-testid="quotes-panel" className="border border-slate-200">
        <EmptyState label="No quote requests yet." />
      </div>
    );
  }
  return (
    <div data-testid="quotes-panel" className="border border-slate-200">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[900px] text-sm">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-[0.25em] text-slate-500 border-b border-slate-200">
              <th className="px-4 py-3">Received</th>
              <th className="px-4 py-3">Customer</th>
              <th className="px-4 py-3">Route</th>
              <th className="px-4 py-3">Service</th>
              <th className="px-4 py-3">Contact</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {quotes.map((q) => (
              <tr key={q.id} data-testid={`quote-row-${q.id}`} className="border-b border-slate-200 hover:bg-white">
                <td className="px-4 py-4 text-slate-500 text-xs">{new Date(q.created_at).toLocaleDateString()}<br />{new Date(q.created_at).toLocaleTimeString()}</td>
                <td className="px-4 py-4">
                  <div className="font-heading font-bold text-slate-900">{q.name}</div>
                  <div className="text-xs text-slate-500">{q.company || "—"}</div>
                </td>
                <td className="px-4 py-4 text-slate-700">
                  <div>{q.pickup_location}</div>
                  <div className="text-slate-400 text-xs">→ {q.dropoff_location}</div>
                </td>
                <td className="px-4 py-4 text-slate-700">
                  <div>{q.service_type}</div>
                  <div className="text-xs text-slate-500">{q.cargo_type || ""} {q.weight ? `· ${q.weight}` : ""}</div>
                </td>
                <td className="px-4 py-4 text-slate-700 text-xs">
                  <div>{q.email}</div>
                  <div>{q.phone}</div>
                </td>
                <td className="px-4 py-4">
                  <select
                    value={q.status}
                    onChange={(e) => onStatusChange(q.id, e.target.value)}
                    data-testid={`quote-status-${q.id}`}
                    className="bg-transparent border border-slate-200 px-2 py-1.5 text-xs uppercase tracking-wider"
                  >
                    {QUOTE_STATUSES.map((s) => <option key={s} value={s} className="bg-brand-bg">{s}</option>)}
                  </select>
                </td>
                <td className="px-4 py-4 text-right">
                  <button onClick={() => onDelete(q.id)} data-testid={`quote-delete-${q.id}`} className="text-slate-500 hover:text-red-400">
                    <Trash2 className="h-4 w-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
